import { Slider } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParamsContext } from "../../../../../context/juno/ParamsContext";

const GuidanceScale = () => {
  const { t } = useTranslation();
  const { guidanceScale, setGuidanceScale, aiEngine } = useParamsContext();
  const [localGuidanceScale, setLocalGuidanceScale] = useState(guidanceScale[aiEngine!]);

  useEffect(() => {
    setLocalGuidanceScale(guidanceScale[aiEngine!]);
  }, [aiEngine, guidanceScale]);

  const handleConfirm = () => {
    setGuidanceScale({ ...guidanceScale, [aiEngine!]: localGuidanceScale });
  };

  const getMin = () => {
    if (aiEngine === "Flux1DevCannyLoRA") {
      return 20;
    }
    if (aiEngine === "IcLightV2") {
      return 0.5;
    }
    return 1;
  };

  const getMax = () => {
    if (["Flux1DevCannyLoRA", "Flux1ProCannyJuno", "Flux1ProDepthJuno"].includes(aiEngine!)) {
      return 40;
    }
    if (["IcLightV2"].includes(aiEngine!)) {
      return 5;
    }

    return 20;
  };

  const min = getMin();
  const max = getMax();

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", mb: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", mb: 1 }}>
          <Typography variant={"body2"}>{t("juno.input.guidanceScale")}</Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row" }} gap={2}>
          <Slider
            getAriaValueText={(value) => `${value}px`}
            value={localGuidanceScale}
            onChange={(e, value) => setLocalGuidanceScale(value as number)}
            onChangeCommitted={handleConfirm}
            step={0.5}
            min={min}
            max={max}
          />
          <Box
            sx={{
              width: "120px",
              bgcolor: "rgba(0, 0, 0, 0.1)",
              px: 1,
              py: 0.5,
              justifyContent: "center",
              display: "flex",
              borderRadius: "5px",
            }}
          >
            <Typography variant={"body2"}>{localGuidanceScale}</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default GuidanceScale;
